import { AnalyticsBrowser } from '@segment/analytics-next'
import { SEGMENT_KEY } from "@/config-global.jsx";
import { handleError } from "@/services/errorHandler.js";

let analytics

// Why do I need this? if it's always used one time its not repetitive,
export const EVENT_NAMES = {
    CONTENT_GENERATED: 'content-generated',
    CONTENT_MANUALLY_CHANGED: 'content-manually-changed',
    CONTENT_COPIED: 'content-copied',
    HTML_DOWNLOADED: 'html-downloaded',
    CONTENT_ADJUSTED: 'content-adjusted',
    CONTENT_REGENERATED: 'content-regenerated',
    NAVIGATED_TO_STUDIO_FROM_LIBRARY: 'navigated-to-studio-from-library',
    CONTENT_CARD_CLICKED: 'content-card-clicked',
    CHOSEN_PRODUCT_CHANGED: 'chosen-product-changed',
    APPLY_CONTENT_TO_MARKETING_PLAN: 'apply-content-to-marketing-plan',
    MARKETING_CONTENT_REPLACED: 'marketing-content-replaced',
    NAVIGATED_TO_STUDIO_FROM_CALENDAR: 'navigated-to-studio-from-calendar',
    SCHEDULED_MATERIAL_DELETED: 'scheduled-material-deleted',
    CREATE_CONTENT_FROM_NAVBAR: 'create-content-from-navbar',
    CREATE_CONTENT_FROM_CALENDAR: 'create-content-from-calendar',
    CREATION_FLOW_CHANGED_EMAIL_TYPE: 'creation-flow-changed-email-type',
    CREATION_FLOW_CHANGED_USE_CASE: 'creation-flow-changed-use-case',
    CREATION_FLOW_CHANGED_CUSTOM_PROMPT_CHANGED: 'creation-flow-changed-custom-prompt-changed',
    INTEGRATION_CONNECTION_STARTED: 'integration-connection-started',
    INTEGRATION_CONNECTION_ENDED: 'integration-connection-ended',
    INTEGRATION_CONNECTION_FAILED: 'integration-connection-failed',
    INTEGRATION_COMING_SOON_CLICKED: 'integration-coming-soon-clicked',
    MARKETING_MATERIAL_DELETED: 'marketing-material-deleted',
    LIBRARY_CHOSEN_TOPIC_CHANGED: 'library-chosen-topic-changed',
    CONTENT_SCHEDULED_ON_CALENDAR: 'content-scheduled-on-calendar',
    CONTENT_REMOVED_FROM_CALENDAR: 'content-removed-from-calendar',
    CONTENT_SCHEDULE_CHANGED_ON_CALENDAR: 'content-schedule-changed-on-calendar',
    MARKETING_MATERIAL_TEMPLATE_UPDATED: 'marketing-material-template-updated',
    UPDATE_SCHEDULE_MATERIAL_AFTER_CAMPAIGN_SCHEDULE_CHANGE: 'update-schedule-material-after-campaign-schedule-change',
    CREATE_SCHEDULE_MATERIAL_AFTER_CAMPAIGN_CREATED: 'create-schedule-material-after-campaign-created',
    INJECT_INITIAL_EMAIL_TEMPLATE: 'inject-initial-email-template',
    TEMPLATE_DEPLOYED_TO_KLAVIYO: 'template-deployed-to-klaviyo',
    TEMPLATE_ONLY_DEPLOYED_TO_KLAVIYO: 'template-only-deployed-to-klaviyo',
    CAMPAIGN_DEPLOYED_TO_KLAVIYO: 'campaign-deployed-to-klaviyo',
    CAMPAIGN_DELETED: 'campaign-deleted',
    COUPON_MENTIONED: 'coupon-mentioned',
    TEXT_ADJUSTED: 'text-adjusted',
    IMAGE_CHOSEN: 'image-chosen',
    PRODUCT_SEARCHED_ON_EMAIL_STUDIO_IMAGE_DIALOG: 'product-searched-on-email-studio-image-dialog',
    PRODUCT_SEARCHED_ON_MATERIAL_CREATING_FLOW: 'product-searched-on-material-creating-flow',
    CREATION_DRAWER_OPENED: 'creation-drawer-opened',
    CREATION_DRAWER_CLOSED: 'creation-drawer-closed',
    INITIALIZE_START: 'initialize-start',
    INITIALIZE_CHECK: 'initialize-check',
    INITIALIZE_END: 'initialize-end',
    LEAVE_STUDIO: 'leave-studio',
    ACCEPT_CONTENT_SUGGESTION_FOR_A_STORE_EVENT: 'accept-content-suggestion-for-a-store-event',
    DISMISS_NOTIFICATION: 'dismiss-notification',
    LOGOUT: 'logout',
    PRIVACY_POLICY_CLICKED: 'privacy-policy-clicked',
}

/* This is the Adapter layer to the 3rd party analytics library we gonna use, currently we will use segment to collect the event and stream them into Mixpanel for the client. */
export const AnalyticsService = {
    init() {
        try {
            console.log('Analytics init')
            analytics = AnalyticsBrowser.load({ writeKey: SEGMENT_KEY })
        } catch (e) {
            console.log(e)
            handleError(e)
        }

    },
    identify(userId, data = {}) {
        try {
            if (!analytics) return
            analytics.identify(userId, data)
        } catch (e) {
            console.log(e)
            handleError(e)
        }
    },
    track(eventName, data = {}) {
        try {
            if (!analytics) return
            analytics.track(eventName, data)
        } catch (e) {
            console.log(e)
            handleError(e)
        }

    },
    group(groupId, data = {}) {
        try {
            if (!analytics) return
            analytics.group(groupId, data)
        } catch (e) {
            console.log(e)
            handleError(e)
        }
    },
    page(pageName, data = {}) {
        try {
            if (!analytics) return
            analytics.page(pageName, data)
        } catch (e) {
            console.log(e)
            handleError(e)
        }

    }
}
